import React, { Dispatch, SetStateAction } from 'react';
import { useFormField } from './FormFieldContext';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Drawer,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSidePanel } from '../../contexts/SidePanelContext';
import { Option } from '../edit/FormFieldContext';

interface HelpTextDrawerProps {
  isHelpDrawerOpen: boolean;
  setIsHelpDrawerOpen: Dispatch<SetStateAction<boolean>>;
}

const HelpTextSideDrawer: React.FC<HelpTextDrawerProps> = (
  props: HelpTextDrawerProps,
) => {
  const { isHelpDrawerOpen, setIsHelpDrawerOpen } = props;
  const { fieldMeta, field, options } = useFormField();
  const { isOpen: isSidePanelContextOpen } = useSidePanel();

  let lookupOptionsWithHelptext: Option[] = [];
  if (options !== undefined) {
    lookupOptionsWithHelptext = options?.filter(
      (option) => option.description !== undefined,
    );
  }

  return (
    <Drawer
      anchor="right"
      open={isHelpDrawerOpen}
      onClose={() => setIsHelpDrawerOpen(false)}
      sx={{
        '& .MuiDrawer-paper': {
          zIndex: 1150, // Lower than both drawer and bottom navigation
        },
      }}
    >
      <Box sx={{ width: 375, overflowX: 'hidden' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            p: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
            backgroundColor: '#f0f0f0', // Slightly darker background for the header
          }}
        >
          <Typography
            sx={{ color: '#1A1A1E', fontSize: '24px', fontWeight: '500' }}
          >
            {isSidePanelContextOpen && (
              <IconButton
                onClick={() => setIsHelpDrawerOpen(false)}
                size="small"
                sx={{ marginRight: 2 }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}
            {field.Label || fieldMeta?.Name}
          </Typography>
          {!isSidePanelContextOpen && (
            <IconButton onClick={() => setIsHelpDrawerOpen(false)} size="small">
              <CloseIcon />
            </IconButton>
          )}
        </Box>
        <Box>
          <Box sx={{ padding: 3 }}>
            <Typography sx={{ fontWeight: 'bold' }}>Description</Typography>
            <div
              dangerouslySetInnerHTML={{ __html: fieldMeta.HelpText || '' }}
            ></div>
            {fieldMeta.Lookup &&
              lookupOptionsWithHelptext.map((option: Option, index: number) => {
                const accordionId = `panel-${index}`;
                return (
                  <Box sx={{ my: 2 }} key={index}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`${accordionId}-content`}
                        id={`${accordionId}-header`}
                      >
                        <Typography component="span">{option.label}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>{option.description}</AccordionDetails>
                    </Accordion>
                  </Box>
                );
              })}
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default HelpTextSideDrawer;
